module.exports = __webpack_public_path__ + "static/media/Knight-sword175_3c.8b852dc6.svg";